import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/products`;

export const getAll = async () => {
   const {data} = await axios.get(`${baseUrl}`, config)
   return data

}
export const linkStock = async ({stockCenter = {}, id}) => {
 const {data} = await axios.post(`${baseUrl}/${id}/link-stock-center`, stockCenter, config)
 return data
}

export const unlinkStock = async ({id, stockCenterId}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}/unlink-stock-center/${stockCenterId}`, config)
 return data
}

export const getOne = async ({id}) => {
 const {data} = await axios.get(`${baseUrl}/${id}`, config)
 return data
}


